module.exports = __webpack_public_path__ + "assets/95ed3ada40cf07cd61f97bfec74b79bf.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/drop/11/Drop_Bonus2.mp3
 ** module id = 207
 ** module chunks = 0
 **/